import React, {useCallback, useState} from 'react';

export function useRadioState<Value extends string>(initialValue: Value) {
	const [value, setValue] = useState(initialValue);

	const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setValue(event.currentTarget.value as Value);
	}, []);

	return [value, handleChange, setValue] as const;
}

useRadioState.displayName = 'useRadioState';
